module.exports = __webpack_public_path__ + "static/media/ico-add-scenario.f476229e.svg";